module.exports = __webpack_public_path__ + "img/puzzle2_g.fb80f6fe.svg";